import React from 'react';
import { AccordionItem } from '../../components';
import { mock_checks } from '../../utils/data';

const Accordion = () => {
	return (
		<div className='accordion' id='accordionExample'>
			{mock_checks.map((check) => <AccordionItem key={check.check_id} check={check}/>)}
		</div>
	);
};

export default Accordion;
